import React from 'react'
import { IWogPay } from './useWogPay'

interface IFRefuelHeader {
  pay: IWogPay
  /** What the first step asks for — the page for app users adds the wallet. */
  firstStepCaption?: string
}

/**
 * The header: a step marker above «Заправка водія», and under it what the
 * manager is working on. On step 2 that is the station — which is why the step
 * itself no longer repeats it. The modal and the page for app users share it.
 */
const stepTitle = (
  pay: IWogPay,
  firstStepCaption: string
): { eyebrow: string; driver?: string; caption: string } => {
  if (pay.step === 'station') {
    return { eyebrow: 'Крок 1 з 2', caption: firstStepCaption }
  }

  if (pay.step === 'amount') {
    const { station } = pay
    return {
      eyebrow: 'Крок 2 з 2',
      driver: pay.account?.name,
      caption: station
        ? `АЗК ${station.name} · ${station.address} · код ${station.code}`
        : '',
    }
  }

  if (pay.result?.ok) return { eyebrow: 'Готово', caption: '' }

  // No caption on failure: the screen shows the server's text, and the
  // (status, error) pair is diagnostic — it is read by the flow, never shown.
  return { eyebrow: 'Заправку не розпочато', caption: '' }
}

const RefuelHeader: React.FC<IFRefuelHeader> = ({
  pay,
  firstStepCaption = 'Оберіть акаунт та АЗК',
}) => {
  const { eyebrow, driver, caption } = stepTitle(pay, firstStepCaption)

  return (
    <div className="refuel-title">
      <span className="refuel-title__step">{eyebrow}</span>
      <span className="refuel-title__name">Заправка водія</span>
      {(!!driver || !!caption) && (
        <span className="refuel-title__caption">
          {!!driver && <b className="refuel-title__driver">{driver}</b>}
          {!!driver && !!caption && ' · '}
          {caption}
        </span>
      )}
    </div>
  )
}

export default RefuelHeader
